import { Privacy } from '@/models/enums';
import { IPrivacy } from '@/models/interfaces';
import { PrivacyPolicyStatus, PrivacyPolicyUserContext, importRemoteComponent } from '@kf/ic2fx';
import { AxiosResponse } from 'axios';
import React from 'react';

const systemContext: PrivacyPolicyUserContext = {
  privacyPolicySystemArea: 'EE',
};

const PrivacyPolicyModal = React.lazy(() => importRemoteComponent('shell', 'PrivacyPolicyModal'));

export interface IPrivacyPolicyWallProps {
  privacyPolicyStatus?: Privacy.PrivacyPolicyStatus;
  fetchingStatus: boolean;
  privacyPolicyError: boolean;
  onAccept: (response: AxiosResponse) => void;
  onFailure: () => void;
}

const PrivacyPolicyWall = ({
  privacyPolicyStatus,
  fetchingStatus,
  privacyPolicyError,
  onAccept,
  onFailure,
}: IPrivacyPolicyWallProps) => {
  if (
    privacyPolicyStatus === Privacy.PrivacyPolicyStatus.ACKNOWLEDGED ||
    fetchingStatus ||
    privacyPolicyError
  ) {
    return <></>;
  }

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <div data-testid='privacy-policy-modal-ee'>
        <PrivacyPolicyModal
          systemContext={systemContext}
          useDeclineBanner
          onPrivacyPolicyAccepted={onAccept}
          onUpdateFailure={onFailure}
        />
      </div>
    </React.Suspense>
  );
};

export default PrivacyPolicyWall;
